<p-tabs value="{{activeTabIndex}}">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <p-tab (click)="handleTabChange(2)" value="2">Consulta Pedido Remisión</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      [severity]="'success'" [variant]="undefined" (onClick)="newOrder()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-indicators [charts]="indicatorCharts" [loading]="loadingIndicators"></app-custom-indicators>
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'order'"
        (onRecoverData)="getAllOrdersWithPagination()" (onPageChange)="onPageChange($event)"
        (onReload)="getIndicatorsForGeneralConsultation()" (onFilterChange)="onFilterChange($event)"
        (onExport)="onExport()" (onAction)="onAction($event)">
        <app-custom-button tableExtraButtons [title]="'Cierre masivo'" [label]="'Cierre masivo'" [severity]="'danger'"
          [icon]="'pi pi-times-circle'" [width]="'8rem'" (onClick)="bulkCloseOrders()">
        </app-custom-button>
      </app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'order'"
        (onRecoverData)="getColumnsForDetailConsultation()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="remissionFromOrderHeader.columns"
        [data]="remissionFromOrderData" [previousFilters]="filters" [listRemissionOrderState]="listRemissionOrderState"
        [remissionOrderState]="remissionOrderState" [filterPersistentKey]="'order'"
        [actions]="remissionFromOrderActions" (onAction)="onAction($event)"
        (remissionOrderStateEmit)="onRemissionOrderStateChange($event)"
        (onRecoverData)="getAllRemissionFromOrderWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<app-custom-modal #orderDataModal [header]="'Datos del Pedido'" [width]="'60vw'"
  [inputs$]="inputsForOrderDataModal$" [children]="componentOrderData" hidden>
</app-custom-modal>